"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var PrivateRoute_1 = require("./_helpers/PrivateRoute");
var dashboardlayout_1 = require("./dashboard/dashboardlayout");
var login_1 = require("./user/login");
var Home_1 = require("./Home");
var Service_1 = require("./Service");
var Application_1 = require("./Application");
var KeyToken_1 = require("./KeyToken");
exports.default = (function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(react_router_1.Switch, null,
        React.createElement(react_router_1.Route, { path: '/login', component: login_1.default }),
        React.createElement(dashboardlayout_1.default, null,
            React.createElement(PrivateRoute_1.PrivateRoute, { exact: true, path: '/', component: Home_1.default }),
            React.createElement(PrivateRoute_1.PrivateRoute, { path: '/Service', component: Service_1.default }),
            React.createElement(PrivateRoute_1.PrivateRoute, { path: '/Application', component: Application_1.default }),
            React.createElement(PrivateRoute_1.PrivateRoute, { path: '/KeyToken', component: KeyToken_1.default }))))); });
//<Redirect from='*' to='/' />
//# sourceMappingURL=Layout.js.map